import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import swal from 'sweetalert';

import TextEditor from '../../elements/formElements/TextEditor';
import axios from '../../services/MyAxios';

class CreateNews extends Component {
    constructor(props) {
        super(props);
        this.state = {
            title: '',
            language_id: 1,
            translation_id: null,
            news_category_id: '',
            slug: '',
            short_text: '',
            text: '',
            errors: [],
            languages: [],
            translations: [],
            news_categories: [],
            publication_date: '',
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            casinoCategoryId: null,
        };

        this.handleFieldChange = this.handleFieldChange.bind(this);
        this.handleEditorChange = this.handleEditorChange.bind(this);
        this.handleCreateNewNews = this.handleCreateNewNews.bind(this);
        this.hasErrorFor = this.hasErrorFor.bind(this);
        this.renderErrorFor = this.renderErrorFor.bind(this);
        this.getLanguages = this.getLanguages.bind(this);
        this.getTranslations = this.getTranslations.bind(this);
        this.getNewsCategories = this.getNewsCategories.bind(this);
    }

    getLanguages() {
        axios.get('/crea/api/languages').then((response) => {
            this.setState({
                languages: response.data,
                language_id: response.data[0].id,
            });
        });
    }

    getTranslations() {
        axios.get('/crea/api/news/translations').then((response) => {
            this.setState({
                translations: response.data,
            });
        });
    }

    getNewsCategories() {
        axios.get('/crea/api/news_category/').then((response) => {
            const newsCategories = response.data.data || [];
            const casinoCategory = newsCategories.find((category) => category.name.toLowerCase() === 'casino');

            this.setState({
                news_categories: newsCategories,
                news_category_id: newsCategories[0]?.id || '',
                casinoCategoryId: casinoCategory?.id?.toString(),
            });
        });
    }

    componentDidMount() {
        this.getLanguages();
        this.getTranslations();
        this.getNewsCategories();
    }

    handleEditorChange(text) {
        this.setState({ text });
    }

    handleFieldChange(event) {
        if (event.target.type === 'checkbox') {
            this.setState({
                [event.target.name]: event.target.checked,
            });
            return;
        }

        this.setState({
            [event.target.name]: event.target.value,
        });

        if (event.target.name === 'title') {
            this.setState({
                slug: this.generateSlug(event.target.value),
            });
        }
    }

    generateSlug(title) {
        return title
            .toLowerCase()
            .replace(/ /g, '-')
            .replace(/[^\w-]+/g, '');
    }

    handleCreateNewNews(event) {
        event.preventDefault();

        const news = {
            language_id: this.state.language_id,
            translation_id: this.state.translation_id,
            news_category_id: this.state.news_category_id,
            title: this.state.title,
            slug: this.state.slug,
            short_text: this.state.short_text,
            text: this.state.text,
            publication_date: this.state.publication_date,
            timezone: this.state.timezone,
        };

        axios
            .post('/crea/api/news', news)
            .then((response) => {
                if (response.data && response.data.id) {
                    swal({
                        title: 'Success',
                        text: 'News created correctly',
                        icon: 'success',
                    }).then(() => {
                        this.props.history.push('/news');
                    });
                    return;
                }

                swal({
                    title: 'Error',
                    text: response.data.message || 'Something went wrong...',
                    icon: 'error',
                });
            })
            .catch((error) => {
                if (error.response) {
                    this.setState({
                        errors: error.response.data.errors,
                    });
                } else {
                    this.setState({
                        errors: error.message,
                    });
                }
            });
    }

    hasErrorFor(field) {
        return !!this.state.errors[field];
    }

    renderErrorFor(field) {
        if (this.hasErrorFor(field)) {
            return (
                <span className="invalid-feedback">
                    <strong>{this.state.errors[field][0]}</strong>
                </span>
            );
        }
    }

    render() {
        return (
            <div className="card">
                <div className="card-body">
                    <form onSubmit={this.handleCreateNewNews}>
                        <div className="form-group">
                            <label htmlFor="title">
                                Title <span className="text-danger text-sm">*</span>
                            </label>
                            <input
                                id="title"
                                type="text"
                                className={`form-control ${this.hasErrorFor('title') ? 'is-invalid' : ''}`}
                                name="title"
                                value={this.state.title}
                                onChange={this.handleFieldChange}
                            />
                            {this.renderErrorFor('title')}
                        </div>

                        <div className="form-group">
                            <label htmlFor="slug">
                                Slug <span className="text-danger text-sm">*</span>
                            </label>
                            <input
                                id="slug"
                                type="text"
                                className={`form-control ${this.hasErrorFor('slug') ? 'is-invalid' : ''}`}
                                name="slug"
                                value={this.state.slug}
                                onChange={this.handleFieldChange}
                            />
                            {this.renderErrorFor('slug')}
                        </div>

                        <div className="form-group">
                            <label htmlFor="language_id">
                                Language <span className="text-danger text-sm">*</span>
                            </label>
                            <select
                                id="language_id"
                                className={`form-control ${this.hasErrorFor('language') ? 'is-invalid' : ''}`}
                                name="language_id"
                                value={this.state.language_id}
                                onChange={this.handleFieldChange}
                            >
                                {this.state.languages.map((lang) => (
                                    <option key={lang.name} value={lang.id}>
                                        {lang.name}
                                    </option>
                                ))}
                            </select>
                            {this.renderErrorFor('language_id')}
                        </div>

                        <div className="form-group">
                            <label htmlFor="translation_id">
                                This is translation of <span className="text-danger text-sm">*</span>
                            </label>
                            <select
                                id="translation_id"
                                className={`form-control ${this.hasErrorFor('translation_id') ? 'is-invalid' : ''}`}
                                name="translation_id"
                                onChange={this.handleFieldChange}
                            >
                                <option key="new-article" value="">
                                    --- NEW ARTICLE ---
                                </option>
                                {this.state.translations.map((translation) => (
                                    <option key={translation.title} value={translation.id}>
                                        {translation.title}
                                    </option>
                                ))}
                            </select>
                            {this.renderErrorFor('translation_id')}
                        </div>

                        {!this.state.translation_id && (
                            <div className="form-group">
                                <label htmlFor="news_category_id">
                                    News category <span className="text-danger text-sm">*</span>
                                </label>
                                <select
                                    id="news_category_id"
                                    className={`form-control ${
                                        this.hasErrorFor('news_category_id') ? 'is-invalid' : ''
                                    }`}
                                    name="news_category_id"
                                    defaultValue={this.state.news_category_id}
                                    onChange={this.handleFieldChange}
                                >
                                    {this.state.news_categories.map((record) => (
                                        <option key={record.name} value={record.id}>
                                            {record.name}
                                        </option>
                                    ))}
                                </select>
                                {this.renderErrorFor('news_category_id')}
                            </div>
                        )}

                        <div className="form-group">
                            <label htmlFor="short_text">
                                Short text <span className="text-danger text-sm">*</span>
                            </label>
                            <textarea
                                id="short_text"
                                name="short_text"
                                value={this.state.short_text}
                                onChange={this.handleFieldChange}
                                className={`form-control ${this.hasErrorFor('short_text') ? 'is-invalid' : ''}`}
                            />
                            {this.renderErrorFor('short_text')}
                        </div>

                        <div className="form-group">
                            {this.state.news_category_id === this.state.casinoCategoryId && (
                                <p>
                                    Available dynamic values:{' '}
                                    {'{ news-games-widget-static }, { news-games-widget-random }'}
                                </p>
                            )}
                            <label htmlFor="text">
                                Text <span className="text-danger text-sm">*</span>
                            </label>
                            <input
                                type="hidden"
                                className={`form-control hidden ${this.hasErrorFor('text') ? 'is-invalid' : ''}`}
                            />

                            <TextEditor
                                id="text"
                                name="text"
                                value={this.state.text}
                                onEditorChange={this.handleEditorChange}
                                className={`form-control
                                        ${this.hasErrorFor('text') ? 'is-invalid' : ''}`}
                            />
                            {this.renderErrorFor('text')}
                        </div>
                        {!this.state.translation_id && (
                            <div className="form-group">
                                <label htmlFor="publication_date">
                                    Publication date <span className="text-danger text-sm">*</span>
                                </label>
                                <input
                                    id="publication_date"
                                    type="datetime-local"
                                    className={`form-control ${
                                        this.hasErrorFor('publication_date') ? 'is-invalid' : ''
                                    }`}
                                    name="publication_date"
                                    value={this.state.publication_date}
                                    onChange={this.handleFieldChange}
                                />
                                {this.renderErrorFor('publication_date')}
                            </div>
                        )}
                        <button className="btn btn-primary">Create</button>
                    </form>
                </div>
            </div>
        );
    }
}

export default withRouter(CreateNews);
